import React, { Component } from 'react';

class NavHome extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.4 55.4"><title>logopart_a2_filled</title><path d="M27.7,55.4A27.7,27.7,0,1,1,55.4,27.7V52.9A2.43,2.43,0,0,1,53,55.3H48.2a2.43,2.43,0,0,1-2.4-2.4h0V48.7A29.26,29.26,0,0,1,27.7,55.4Zm0-53A25.25,25.25,0,1,0,46.1,44.9l2.1-2.2V52.8H53V27.7A25.39,25.39,0,0,0,27.7,2.4Zm0,45.7A20.4,20.4,0,1,1,48.1,27.7,20.44,20.44,0,0,1,27.7,48.1Zm0-38.5a18,18,0,1,0,18,18h0a18.18,18.18,0,0,0-18-18Z" transform="translate(0 0)"/><path className="logo-slash" d="M29.9,40.6a2.4,2.4,0,0,1-2.2-1.4l-9-18.8h0a2.37,2.37,0,0,1,1.1-3.2L24.5,15a2.37,2.37,0,0,1,3.2,1.1l9,18.8a2.37,2.37,0,0,1-1.1,3.2h0l-4.7,2.2A1.93,1.93,0,0,1,29.9,40.6Z" transform="translate(0 0)"/>
            </svg>
        );
    }
}

export default NavHome;



// WEBPACK FOOTER //
// ./src/components/All/NavHome.js